import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "general__triangle",
  "use": "general__triangle-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"general__triangle\">\n  <polygon points=\"2,.5 10,6 2,11.5\" stroke-linejoin=\"round\" stroke-width=\"1\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol